module.exports = __webpack_public_path__ + "images/mobile/icon-file-folder-68004abd050b5a2a44dec15c20df5ab5.png";